import { Component, OnInit, Input, OnChanges} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslationService } from 'src/app/Services/Translation/Translation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'embryo-HomePageOneSlider',
  templateUrl: './HomePageOneSlider.component.html',
  styleUrls: ['./HomePageOneSlider.component.scss']
})
export class HomePageOneSliderComponent implements OnInit, OnChanges {

   @Input() isRTL :BehaviorSubject< boolean> = new BehaviorSubject<boolean>( false);
   isRTLLocal:boolean;
   slideConfig : any;

   asd:string = "SLIDER_ONE_1";
   constructor(public trans:TranslationService,public translate: TranslateService) {
      this.isRTL.asObservable().subscribe(x=>this.isRTLLocal = x);
    }

   ngOnInit() {
   }

   ngOnChanges() {
      this.slideConfig = {
         slidesToShow: 1,
         slidesToScroll:1,
         autoplay: true,
         autoplaySpeed: 2000,
         dots: false,
         rtl: this.isRTLLocal,
         responsive: [
          {
             breakpoint: 768,
             settings: {
                arrows: false,
                slidesToShow: 1
             }
             },
          {
             breakpoint: 480,
             settings: {
                arrows: false,
                slidesToShow: 1
             }
          }
         ]
      };
   }

}
